import {connect} from "react-redux";
import ValetExternalMom from "./Create";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../service/fileUpload/action";
import {viewActivity} from "../../../service/Activity/action";
import {createAndSendMom} from "../../../service/Valet/action";

const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    activityByIdDetails:state.Activity.activityByIdDetails,
    createMomResponse:state.Valet.createMomResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            viewActivity,
            createAndSendMom,
            documentUploadUrlPublic
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(ValetExternalMom);
